export function isLeaf(node) {
  return node.field !== undefined;
}
/**
 * A function used to process headerClassName params.
 */


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/models/gridColumnGrouping.js
// module id = 1045
// module chunks = 25